<template>
  <div>
    <el-form label-position="right">
      <title-and-description :field="field" />

      <el-row type="flex" :gutter="30">
        <el-col :span="12">
          <field-filled-by :field="field" />
        </el-col>
        <el-col :span="12">
          <is-field-required :field="field" />
        </el-col>
      </el-row>

      <!-- Enabled Fields -->
      <el-form-item class="sub-item" label="Enable Fields">
        <el-checkbox-group v-model="field.address.enabled_subfields">
          <div class="checkbox-container">
            <el-checkbox v-for="option in subFieldSchema" :label="option.key" :key="option.key">
              {{ option.label }}
            </el-checkbox>
          </div>
        </el-checkbox-group>
      </el-form-item>

      <!-- Required Fields -->
      <el-form-item class="sub-item" label="Required Fields">
        <el-checkbox-group v-model="field.address.required_subfields">
          <div class="checkbox-container">
            <el-checkbox v-for="option in enabledSubFields" :label="option.key" :key="option.key">
              {{ option.label }}
            </el-checkbox>
          </div>
        </el-checkbox-group>
      </el-form-item>

      <!-- Minimal View Fields -->
      <el-form-item class="sub-item" label="Minimal View (Compact)">
        <el-checkbox-group v-model="field.address.minimal_subfields">
          <div class="checkbox-container">
            <el-checkbox v-for="option in enabledSubFields" :label="option.key" :key="option.key">
              {{ option.label }}
            </el-checkbox>
          </div>
        </el-checkbox-group>
        <small class="helper-text">
          These fields will be shown in compact view. Others will appear in popup/drawer.
        </small>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  export default {
    name: 'templates-formComponents-AddressField',
    components: {
      TitleAndDescription: () => import('./TitleAndDescription'),
      IsFieldRequired: () => import('./IsFieldRequired'),
      FieldFilledBy: () => import('./FieldFilledBy'),
    },
    props: ['field', 'fieldsData'],
    data() {
      return {
        // Centralized schema of sub-fields
        subFieldSchema: [
          { key: 'name', label: 'Name', type: 'text' },
          { key: 'address', label: 'Street Address', type: 'text' },
          { key: 'city', label: 'City', type: 'text' },
          { key: 'state', label: 'State/Province', type: 'text' },
          { key: 'zip', label: 'Postal Code', type: 'text' },
          { key: 'country', label: 'Country', type: 'dropdown' },
          // { key: "business_type", label: "Business Type", type: "dropdown" },
          { key: 'mobile', label: 'Mobile Number', type: 'text' },
          { key: 'alternate_mobile', label: 'Alternate Number', type: 'text' },
          { key: 'work_phone', label: 'Work Phone', type: 'text' },
          { key: 'fax', label: 'Fax Number', type: 'text' },
          { key: 'email', label: 'Email', type: 'text' },
          { key: 'website', label: 'Website', type: 'text' },
          // { key: "default", label: "Default", type: "toggle" },
          // { key: "active", label: "Active", type: "toggle" },
        ],
      };
    },
    computed: {
      enabledSubFields() {
        return this.subFieldSchema.filter((f) =>
          this.field.address?.enabled_subfields?.includes(f.key)
        );
      },
    },
    created() {
      if (!this.field.address) {
        this.$set(this.field, 'address', {});
      }
      if (!this.field.address) {
        this.$set(this.field, 'address', {});
      }

      if (!this.field.address.enabled_subfields) {
        this.$set(
          this.field.address,
          'enabled_subfields',
          this.subFieldSchema.map((f) => f.key)
        );
      }
      if (!this.field.address.required_subfields) {
        this.$set(this.field.address, 'required_subfields', []);
      }
      if (!this.field.address.minimal_subfields) {
        this.$set(this.field.address, 'minimal_subfields', ['name', 'address', 'city']);
      }

      if (!this.field.address.values) {
        const defaults = {};
        this.subFieldSchema.forEach((f) => {
          defaults[f.key] = f.type === 'toggle' ? false : '';
        });
        this.$set(this.field.address, 'values', defaults);
      }
    },
    watch: {
      'field.address.enabled_subfields'(newEnabled) {
        this.field.address.required_subfields = this.field.address.required_subfields.filter(
          (key) => newEnabled.includes(key)
        );
        this.field.address.minimal_subfields = this.field.address.minimal_subfields.filter((key) =>
          newEnabled.includes(key)
        );
      },
    },
  };
</script>

<style lang="scss">
  .checkbox-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  }

  .sub-item {
    background: #fafafa;
    padding: 12px 16px;
    border-radius: 6px;
    margin-bottom: 16px;
  }

  .el-form-item__label {
    font-weight: 600;
    color: #444;
  }
  .helper-text {
    font-size: 12px;
    color: #777;
    margin-top: 4px;
    display: inline-block;
  }
</style>
